module.exports = __webpack_public_path__ + "img/prolungato_mediale_sx.f9740b7b.png";